import { render, staticRenderFns } from "./OwnerLabel.vue?vue&type=template&id=f263c3ea"
import script from "./OwnerLabel.vue?vue&type=script&lang=js"
export * from "./OwnerLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports